export const cartListPath = '/carrito';
export const cartPath = (storeId) => `/carrito/${storeId}`;
export const checkoutPath = (storeId) => `/checkout/${storeId}`;

// Badge: suma de itemCount de los carritos abiertos. Con exactamente un
// carrito va directo a él; con varios (o ninguno) a la lista.
export const cartCount = (summaries) =>
    (summaries || []).reduce((sum, s) => sum + (Number(s.itemCount) || 0), 0);

export const cartTargetPath = (summaries) =>
    summaries && summaries.length === 1
        ? cartPath(summaries[0].storeId)
        : cartListPath;

export const UNAVAILABLE_LABELS = {
    product_unavailable: 'Ya no está disponible',
    option_unavailable: 'Esa variante se agotó',
};

export const BLOCKED_REASON_LABELS = {
    empty: 'Tu carrito está vacío.',
    unavailable_items:
        'Quitá los productos que ya no están disponibles para continuar.',
    no_payment_option:
        'Esta tienda todavía no cobra online. Podés consultar por videollamada.',
};
